<template>
    <section>
        <div class="carousel-container" ref="carouselContainer" @scroll="onScroll" @mouseover="stopScroll"
            @mouseleave="startScroll" @wheel="onUserScroll">
            <div class="main-container" v-for="(group, index) in programs" :key="index">
                <div class="program-container" :class="{ 'single-card-layout': group.length === 1 }">
                    <template v-if="group.length === 1">
                        <div class="program-image single" v-bind:style="getImageUrl(group)">
                        </div>
                        <div class="program-card single">
                            <span class="title-card">{{ group[0].title }}</span>
                            <span class="description-card">{{ group[0].shortDescr }}</span>
                            <specialButtonMicro class="button-micro isWhite"  @action="setItem(item)"   />
                        </div>
                    </template>
                    <template v-else>
                        <div class="column">
                            <div class="row" v-for="(item, idx) in group" :key="idx">
                                <div class="program-card">
                                    <span class="title-card">{{ item.title }}</span>
                                    <span class="description-card">{{ item.shortDescr }}</span>
                                    <specialButtonMicro class="button-micro isWhite" @action="setItem(item)"  />
                                </div>
                                <div class="program-image" v-bind:style="getImageUrl(item)">
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="pagination-dots">
                <span v-for="(group, index) in programs" :key="index" class="dot"
                    :class="{ active: index === currentSlideIndex }" @click="goToSlide(index)"></span>
            </div>
        </div>
    </section>
</template>

<script>
import specialButtonMicro from "../specialButtonMicro.vue";
import { mapActions } from 'vuex';
import { url } from "@/global/index"

export default {
    components: {
        specialButtonMicro,
    },
    data() {
        return {
            scrollInterval: null,
            scrollDelay: 3000, // Intervalo de 3 segundos
            currentSlideIndex: 0,
            userHasScrolled: false,
            lastScrollLeft: 0,
            userInteractionTimeout: null,
            url
        };
    },
    async created(){
        await this.getAllInfoFtr("feature") 
    },
    computed: {
        programs() {
            const paginated = structuredClone(this.$store.getters['feature/data']);

            if(!Array.isArray(paginated)){
                return [] 
            }
           
            let filtered = []
            let group = []
            for (const item of paginated) {
                if(group.length<2){
                    group.push(item.program)
                }else{
                    filtered.push(group)
                    group = []
                    group.push(item.program)
                }
            }
            if(group.length>0){
                filtered.push(group)
                group = []
            }
            return filtered
        },
    },
    methods: {
        ...mapActions("feature", ["getAllInfoFtr"]),
        setItem(item){
            localStorage.setItem('program', JSON.stringify(item))
            this.$router.push({ path: "/web-app", query: { a: 'programa-individual' } });
        },
        getImageUrl(item){
            const imageUrl = item.mobileImg ? `${url}/program-image/${item.id}/${item.mobileImg}` :  require('@/assets/programImagen.png')
            return {'background-image': `url(${imageUrl})`}
        },
        startScroll() {
            if (this.userHasScrolled) return;
            this.stopScroll();
            this.scrollInterval = setInterval(() => {
                this.nextSlide();
            }, this.scrollDelay);
        },
        stopScroll() {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        },
        nextSlide() {
            const nextIndex = (this.currentSlideIndex + 1) % this.programs.length;
            this.goToSlide(nextIndex);
        },
        goToSlide(index) {
            const container = this.$refs.carouselContainer;
            this.currentSlideIndex = index;
            container.scrollTo({
                left: container.clientWidth * index,
                behavior: 'smooth'
            });
        },
        onScroll() {
            const container = this.$refs.carouselContainer;
            const newIndex = Math.round(container.scrollLeft / container.clientWidth);
            if (newIndex !== this.currentSlideIndex) {
                this.currentSlideIndex = newIndex;
            }
            const scrollChanged = Math.abs(container.scrollLeft - this.lastScrollLeft) > 10;
            this.lastScrollLeft = container.scrollLeft;

            if (!this.userHasScrolled && this.scrollInterval && scrollChanged) {
                this.userHasScrolled = true;
                this.stopScroll();
                this.onUserInteraction();
            }
        },
        onUserScroll() {
            if (!this.userHasScrolled) {
                this.userHasScrolled = true;
                this.stopScroll();
                this.onUserInteraction();
            }
        },
        onUserInteraction() {
            clearTimeout(this.userInteractionTimeout);
            this.userInteractionTimeout = setTimeout(() => {
                this.userHasScrolled = false;
                this.startScroll();
            }, 5000);
        }
    },
    mounted() {
        this.startScroll();
    },
    beforeDestroy() {
        this.stopScroll();
        clearTimeout(this.userInteractionTimeout);
    }
};
</script>

<style scoped>
section {
    position: relative;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
}

.carousel-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    gap: 0;
    box-sizing: border-box;
    padding-bottom: 15vh;
}

.carousel-container::-webkit-scrollbar {
    display: none;
}

.main-container {
    flex: 0 0 100%;
    display: flex;
    padding: 0;
    flex-direction: column;
    scroll-snap-align: center;
    box-sizing: border-box;
}

.row {
    display: flex;
    flex-direction: row;
    gap: 2.5vw;
}

.column {
    display: flex;
    flex-direction: column;
    gap: 2.5vw;
}

.program-container {
    display: flex;
    flex-direction: row;
    gap: 2.5vw;
    padding-bottom: 2.5vw;
    box-sizing: border-box;
}

/* Caso especial para un solo ítem */
.program-container.single-card-layout {
    flex-direction: column;
    gap: 2.5vw;
    align-items: flex-start;
    width: 100%;
    height: 100%;
}

.program-card {
    flex: 1;
    display: flex;
    padding: 3.4884vw;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 4.6512vw;
    background: var(--purple, #B359F8);
    box-sizing: border-box;
}

.program-image {
    flex: 1;
    width: 40vw;
    object-fit: cover;
    display: flex;
    padding: 7.6744vw 3.4884vw;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2.3256vw;
    align-self: stretch;
    border-radius: 4.6512vw;
    
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.program-image.single {
    width: 100%;
    height: 50%;
    padding-bottom: 1.25vw;
    background: url("@/assets/programImagen.png") lightgray 20.2326vw -50.3023vw / 100.21%;
}

.program-card.single {
    height: 50%;
    padding-top: 20px;
}

.title-card {
    color: #FFF;
    font-family: Manrope;
    font-size: 5vw;
    font-weight: 400;
    line-height: normal;
}

.description-card {
    padding-top: 2.5vw;
    color: #FFF;
    font-family: Manrope;
    font-size: 2.5vw;
    font-weight: 400;
    line-height: normal;
}

.button-micro {
    align-self: flex-end;
    margin-top: auto;
}

.title-image {
    color: #FFC700;
    font-family: Kemio;
    font-size: 11.6279vw;
    font-weight: 400;
    line-height: 9.3023vw;
    text-transform: uppercase;
}

.pagination-dots {
    position: absolute;
    bottom: 22vw;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 1vw;
    z-index: 5;
}

.dot {
    width: 1vw;
    height: 1vw;
    background-color: #9a9494;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
}

.dot.active {
    width: 1.5vw;
    height: 1.5vw;
    background-color: #B359F8;
}
</style>
